module.exports = __webpack_public_path__ + "static/desktop/img/bp-one.5730e628.jpg";